import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  margin-top: 12px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 0.75rem 0;
  position: absolute;
  top: -34px;
  right: 32px;

  > label > p {
    font-size: 0.8rem;
  }
`;

export const Label = styled.div`
  margin: 0;
  font-size: 0.9rem;
`;

export const ValuesLine = styled.div`
  display: flex;
  align-items: center;

  & > .rangeInput {
    flex: 1;
  }
`;
